import DefaultPage from "../components/defaultPage";
import PageHeader from "../components/pageHeader";
import TextBlock from "../components/textBlock";
import { Helmet } from "react-helmet";
import privacyPolicy from "../config/policy";
import { Fragment } from "react";

const renderBlocks = (blocks) =>
  blocks.map((block) => (
    <Fragment key={block.num || block.label}>
      {block.type === "field" ? (
        <p>
          <b>{block.label}:</b> {block.value}
        </p>
      ) : (
        <p>
          <b>{block.num}.</b> {block.text}
        </p>
      )}
      {block.items && (
        <ul>
          {block.items.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      )}
    </Fragment>
  ));

const PrivacyPage = () => {
  return (
    <>
      <Helmet>
        <title>Политика конфиденциальности</title>
      </Helmet>
      <PageHeader
        title="Политика конфиденциальности"
        breadcrumbs={[
          {
            link: "/",
            text: "Политика конфиденциальности",
          },
        ]}
      />
      <DefaultPage>
        <TextBlock>
          <h2>{privacyPolicy.title}</h2>
          <h4>{privacyPolicy.subtitle}</h4>
          <p>{privacyPolicy.operator}</p>
          <p>{privacyPolicy.edition}</p>
          {privacyPolicy.sections.map((section) => (
            <Fragment key={section.id}>
              <h3>{section.id}. {section.title}</h3>
              {renderBlocks(section.blocks)}
              {section.subsections?.map((subsection) => (
                <Fragment key={subsection.id}>
                  <h4>{subsection.id}. {subsection.title}</h4>
                  {renderBlocks(subsection.blocks)}
                </Fragment>
              ))}
            </Fragment>
          ))}
          <h3>{privacyPolicy.requisites.title}</h3>
          {privacyPolicy.requisites.fields.map((field) => (
            <p key={field.label}>
              <b>{field.label}:</b> {field.value}
            </p>
          ))}
        </TextBlock>
      </DefaultPage>
    </>
  );
};

export default PrivacyPage;
